
import Vue, { PropType } from 'vue';
import i18n from '../i18n';
import { Icon } from '@descomplica/vue-components';
import { ShowCaseUrl } from '@/components/ShowCaseAccordion.vue';
import { ShowCaseHelper } from '@/helpers/trial';
import { TRIAL_SHOW_CASE_STEPS } from '@/enum/trial/trialShowCaseSteps.enum';

const HOME_PAGE = 'home';

const ROUTER_HASH = '#scheduledActivities';

export default Vue.extend({
  i18n,
  components: {
    Icon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    urls: {
      type: Array as PropType<ShowCaseUrl[]>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    bottomBarColor: {
      type: String,
      required: true,
    },
    currentUserPeriod: {
      type: Number,
      default: 0,
    },
    showCaseHasFinished: {
      type: Boolean,
      default: false,
    },
    courseSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isCompleted: false,
      isShowCaseFinished: this.showCaseHasFinished,
    };
  },
  watch: {
    showCaseHasFinished() {
      this.isShowCaseFinished = this.showCaseHasFinished;
    },
  },
  mounted() {
    this.isCompleted = this.stepIsCompleted();
  },
  methods: {
    stepIsCompleted(): boolean {
      return ShowCaseHelper.stepIsCompleted(this.type as TRIAL_SHOW_CASE_STEPS);
    },
    stepsAreFinished(): boolean {
      return ShowCaseHelper.stepsAreFinished();
    },
    scrollPage(): void {
      document
        .querySelector('#scheduledActivities')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    getPath(): string {
      const showCaseUrls = this.urls as ShowCaseUrl[];

      if (this.type === TRIAL_SHOW_CASE_STEPS.FIRST_CLASSROOM) {
        const { slug } = this.$store.getters.currentCourse;
        const urls = showCaseUrls.find((url) => url.course === slug)?.firstClassroomUrl as string;
        return urls[this.currentUserPeriod];
      }
      return '';
    },
    getRoute(): void {
      const path = this.getPath();
      const routes: any = {
        firstClassroom: () => this.$router.push({ path }),
        liveClassroom: () =>
          this.$router.currentRoute.name === HOME_PAGE
            ? this.scrollPage()
            : this.$router.push({
                name: HOME_PAGE,
                hash: ROUTER_HASH,
              }),
        selectiveProcess: () =>
          this.$router.push({
            query: { openSelectiveProcess: 'open' },
          }),
        microcertificate: () =>
          this.$router.push({
            query: { openMicrocertificate: 'open', courseSlug: this.courseSlug },
          }),
        discount: () =>
          this.$router.push({
            query: { openCoupon: 'open' },
          }),
      };
      routes[this.type]();
    },
    completeStep(): void {
      ShowCaseHelper.completeStep(this.type as TRIAL_SHOW_CASE_STEPS);
      this.isCompleted = this.stepIsCompleted();
      const stepsAreFinished = this.stepsAreFinished();
      if (stepsAreFinished) {
        this.$emit('hasFinished');
      }
      this.$emit('setProgress');
    },
    openUrl(): void {
      if (this.type === 'discount' && !this.stepsAreFinished()) {
        return;
      }
      this.getRoute();
      this.completeStep();
    },
  },
});
